var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlienOptimized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.55 13.395c1.478 2.46 1.261 5.355-.508 6.525-1.769 1.14-4.408.075-5.901-2.385-1.48-2.46-1.247-5.385.521-6.525 1.77-1.14 4.408-.075 5.888 2.385ZM15 23.625c2.9 0 3.625-1.125 3.625-1.125s-.725 3-3.625 3-3.625-2.955-3.625-3c0 0 .725 1.125 3.625 1.125Zm8.337-12.615c1.77 1.14 2.002 4.065.523 6.525-1.494 2.46-4.133 3.525-5.902 2.385-1.769-1.17-1.986-4.065-.507-6.525s4.117-3.525 5.886-2.385ZM15 27c3.625 0 11.6-7.71 11.6-13.5S21.394 3 15 3C8.605 3 3.4 7.71 3.4 13.5S11.375 27 15 27Zm0-27c7.975 0 14.5 6.06 14.5 13.5C29.5 19.62 21.264 30 15 30 8.736 30 .5 19.62.5 13.5.5 6.06 7.025 0 15 0Z",
    fill: "#02E4C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlienOptimized);
export default __webpack_public_path__ + "static/media/alien-optimized.355e3f3bfd77e488835c8fc9313b8033.svg";
export { ForwardRef as ReactComponent };